export function inputAutowidthDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: inputAutowidthDirectiveCtrl,
	};
}

export class inputAutowidthDirectiveCtrl {
	constructor($element, $scope) {
		'ngInject';
		const adjust = () => {
			$element.css('width', '0');
			const neededWidth = $element[0].scrollWidth + 9; // 9px minimum
			$element.css('width', `${neededWidth}px`);
		};
		$element.on('input', adjust);
		$scope.$on('sh-input-autowidth:adjust', adjust);
		adjust();
	}
}
